import type { FC } from "react"

import type { UserInfoField } from "../../generated/graphql"
import { useCommunityCustomization } from "../../utils/useCommunityCustomization"
import { CompleteAccountForm } from "../auth-checkout/CompleteAccountForm"
import { ModalBase } from "../ModalBase"
import { UbiqButtonType } from "../UbiqButton"

const COMPLETE_ACCOUNT_MODAL_PANEL_STYLES =
  "w-[calc(100vw-32px)] pt-12 px-6 pb-10 font-mono sm:max-w-[480px] sm:px-[54px] flex flex-col items-center"

interface CompleteAccountProps {
  requiredFields: UserInfoField[]
  modalViewportStyles: string
  modalContainerStyles: string
  modalPanelStyles: string
  onComplete: (email?: string) => void | Promise<void>
  onBack: () => void
}

export const CompleteAccount: FC<CompleteAccountProps> = ({
  requiredFields,
  modalViewportStyles,
  modalContainerStyles,
  modalPanelStyles,
  onComplete,
  onBack,
}) => {
  const customizationData = useCommunityCustomization()
  if (!customizationData) return null
  const modalWindowStyles = customizationData.styles.global.modalWindow

  return (
    <ModalBase
      allowPanelOverflowVisible
      dialogContainerStyles={modalContainerStyles}
      dialogPanelStyles={`${COMPLETE_ACCOUNT_MODAL_PANEL_STYLES} ${modalWindowStyles.container} ${modalPanelStyles}`}
      dialogViewportStyles={modalViewportStyles}
      disableInitialFocus
      disableVisualViewportTracking
      show
    >
      <h2 className={`mb-2 text-center text-primary-h2 ${modalWindowStyles.title}`}>
        Complete the account
      </h2>
      <p className={`mb-6 text-center text-body-lg text-textPrimary ${modalWindowStyles.subtitle}`}>
        We need some more information about you to be able to complete your account.
      </p>

      <CompleteAccountForm
        containerClassName="w-full"
        fieldsContainerClassName="flex flex-col gap-4 w-full"
        onComplete={onComplete}
        requiredFields={requiredFields}
        requireEmailConfirmation={true}
        showIntro={false}
        showTerms={false}
        submitButtonStyles="mx-auto mt-6 !w-fit"
        submitButtonType={UbiqButtonType.LIGHT}
        submitLabel="CONFIRM"
        syncUserOnSubmit={false}
      />

      <p className="mt-6 text-center font-mono text-body-md text-textPrimary">
        Need help?{" "}
        <a
          className="font-bold underline"
          href="mailto:ok@werz.at"
          rel="noreferrer"
          target="_blank"
        >
          Contact us
        </a>
      </p>
      <div className="mt-6 w-full text-center">
        <button
          className="mx-auto block font-mono text-primary-h5 font-bold underline cursor-pointer appearance-none border-0 bg-transparent p-0"
          onClick={onBack}
          type="button"
        >
          GO BACK
        </button>
      </div>
    </ModalBase>
  )
}
